import React, { Fragment } from 'react';
import {
    PreviewContainer,
    PreviewImage,
    PreviewActions,
    DarkButton,
    EmptyPreview,
    PreviewImageOverlay,
} from '../style';
import { Text } from '../../../../UI/Text';
import { getPreviewItemBackgroundImage } from '../../../../Components/Modals/GymTvConfigurationsModal/utils';
import { convertDisplayTypeNumberToName } from '../utils';
import { Icon } from '../../../../Components/Icons/Icons';
import { HoverableFadingContainer } from '../../../../Components/HoverableFadingContainer';

export const SettingsPreviewItem = ({ modalType, title, onAction, onDelete, item }) => {
    return (
        <Fragment>
            {title && (
                <Text opacity={0.8} weight={'bold'} fontSize={16} marginBottom={'8px'}>
                    {title}
                </Text>
            )}

            {!item ? (
                <EmptyPreviewItem onAction={onAction} />
            ) : (
                <FilledPreviewItem onDelete={onDelete} onAction={onAction} itemSelected={item} />
            )}
        </Fragment>
    );
};

export const EmptyPreviewItem = ({ onAction }) => (
    <PreviewContainer>
        <EmptyPreview>
            <DarkButton onClick={onAction}>Add</DarkButton>
        </EmptyPreview>
    </PreviewContainer>
);

export const FilledPreviewItem = ({ onAction, onDelete, itemSelected: { content_type } }) => (
    <PreviewContainer>
        <PreviewImage background={getPreviewItemBackgroundImage(content_type)}>
            <PreviewImageOverlay>
                <HoverableFadingContainer>
                    <Icon.Box onClick={onAction} cursor={'pointer'} opacity={0.5} size={'24x24'}>
                        <Icon.Edit />
                    </Icon.Box>
                </HoverableFadingContainer>
                <HoverableFadingContainer>
                    <Icon.Box onClick={onDelete} cursor={'pointer'} size={'24x24'}>
                        <Icon.Delete />
                    </Icon.Box>
                </HoverableFadingContainer>
            </PreviewImageOverlay>
        </PreviewImage>
        <PreviewActions>
            <Text opacity={0.8} weight={100} fontSize={14}>
                {convertDisplayTypeNumberToName(content_type)}
            </Text>
        </PreviewActions>
    </PreviewContainer>
);

SettingsPreviewItem.defaultProps = {
    modalType: 0,
    selected: 'Class programme',
    onAction: () => {},
    onDelete: () => {},
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/Settings/SettingsPreviewItem.js